import { SxProps, TextField as TextFieldMui, Theme } from "@mui/material";
import styled from "@mui/styles/styled";
import { BLACK, LIGHT_GREY } from "../../../../utils/colors";

interface TextFieldProps {
  label: string;
  value?: string | number | null;
  name?: string;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  placeholder?: string;
  className?: string;
  sx?: SxProps<Theme>;
  onChange?: any;
  startAdornment?: JSX.Element;
  endAdornment?: JSX.Element;
}

export const OpaqueInput = styled(TextFieldMui)(() => ({
  // marginBottom: "24px",
  // width: "100%",
  // height: "12px",
  "label + &": {
    marginTop: "10px",
  },

  "& .MuiInputBase-root": {
    height: "50px !important",
    background: LIGHT_GREY,
  },

  "& .MuiInputBase-input": {
    // padding: 0,
    width: "100%",
    fontWeight: 500,
    color: BLACK,
  },
}));

export const TextField = ({
  label,
  error,
  name,
  helperText,
  value,
  placeholder,
  className,
  disabled = false,
  onChange,
  sx,
  startAdornment,
  endAdornment,
}: TextFieldProps) => {
  return (
    <OpaqueInput
      variant="outlined"
      label={label}
      name={name}
      value={value}
      className={className}
      disabled={disabled}
      error={error}
      helperText={helperText}
      placeholder={placeholder}
      onChange={onChange}
      sx={sx}
      InputProps={{
        // ...params.InputProps,
        startAdornment:
          // <>
          startAdornment,
        /* {params.InputProps.startAdornment}
          </> */
        // ,
        endAdornment:
          //   <>
          endAdornment,
        //     {params.InputProps.endAdornment}
        //   </>
        // ),
      }}
    />
  );
};
